<!-- Add profile Modal -->
    <div style="margin-top: 25px;">
        <div class="modal-header add-sales-header">
            <button type="button" class="btn-close" (click)="modalRef.hide()" data-bs-dismiss="modal"
                aria-label="Close"></button>
        </div>
        <div class="modal-body add-sales-padding">
            <h1 class="modal-title">Add Sales Agent</h1>
            <form [formGroup]="addProfile" (ngSubmit)="submitProfile()" class="modal-form">
                <div class="form-floating"
                    [ngClass]="fullName?.invalid && (fullName?.dirty || fullName?.touched)?'invalid-input':''">
                    <input type="text" class="form-control" formControlName="fullName" id="floatingInput"
                        placeholder="name@example.com" maxlength="50">
                    <label for="floatingInput">Full Name</label>
                    <ng-container *ngIf="fullName?.invalid && (fullName?.dirty || fullName?.touched)">
                        <span class="invalid-input-text-err" *ngIf="fullName?.errors?.required">Full Name is
                            required</span>
                            <span class="invalid-input-text-err" *ngIf="fullName?.errors?.pattern">Full Name is
                                invalid</span>
                    </ng-container>
                </div>

                <div class="form-floating"
                    [ngClass]="mobile?.invalid && (mobile?.dirty || mobile?.touched)?'invalid-input':''">
                    <input type="text" class="form-control" formControlName="mobile"
                        id="floatingInput" placeholder="name@example.com" minlength="10" maxlength="10" appNumbersonly
                        (focusin)="showCountryCode=true " (focusout)="mobile?.errors?.required?showCountryCode=false:
                    '' " (focusout)="mobile?.errors?.minlength?showCountryCode=false:'' ">
                    <label for="floatingInput">Phone Number (+1)</label>
                    <ng-container *ngIf="mobile?.invalid && (mobile?.dirty || mobile?.touched)">
                        <span class="invalid-input-text-err" *ngIf="mobile?.errors?.required">Phone Number is
                            required</span>
                        <span class="invalid-input-text-err" *ngIf="mobile?.errors?.minlength">Phone Number should not
                            be less than 10 numbers</span>
                            <span class="invalid-input-text-err" *ngIf="mobile?.errors?.pattern">Phone Number should not
                                be less than 10 numbers</span>
                    </ng-container>
                </div>

                <div class="form-floating"
                    [ngClass]="emailId?.invalid && (emailId?.dirty || emailId?.touched)?'invalid-input':''">
                    <input type="text" class="form-control" formControlName="emailId" id="floatingInput"
                        placeholder="name@example.com" maxlength="50" readonly onfocus="this.removeAttribute('readonly');">
                    <label for="floatingInput">Email ID</label>
                    <ng-container *ngIf="emailId?.invalid && (emailId?.dirty || emailId?.touched)">
                        <span class="invalid-input-text-err" *ngIf="emailId?.errors?.required">Email is
                            required</span>
                        <span class="invalid-input-text-err" *ngIf="emailId?.errors?.pattern">Email is
                            invalid</span>
                    </ng-container>
                </div>

                <div class="form-floating"
                [ngClass]="password?.invalid && (password?.dirty || password?.touched)?'invalid-input':''">
                <input [type]="showPass?'text':'password'" class="form-control" formControlName="password" id="floatingInput"
                    placeholder="name@example.com" minlength="8" maxlength="20" readonly onfocus="this.removeAttribute('readonly');">
                <label for="floatingInput">Password</label>
                <span class="hide-eye" (click)="showPass=!showPass"><img
                    src="assets/images/{{showPass?'show':'hide'}}-password.svg" alt="hide-password"></span>
                    <ng-container *ngIf="password?.invalid && (password?.dirty || password?.touched)">
                        <span class="invalid-input-text-err" *ngIf="password?.errors?.required">Password is
                            required</span>
                        <span class="invalid-input-text-err-two" *ngIf="password?.errors?.pattern">Password must be 8 to 20 
                        characters, atleast one alpha-numeric, one special character, one uppercase and one lowercase.</span>
                    </ng-container>
            </div>

                <div class="form-floating"
                    [ngClass]="address?.invalid && (address?.dirty || address?.touched)?'invalid-input':''">
                    <input type="text" class="form-control" formControlName="address" id="floatingInput"
                        placeholder="name@example.com" maxlength="100">
                    <label for="floatingInput">Address</label>
                    <ng-container *ngIf="address?.invalid && (address?.dirty || address?.touched)">
                        <span class="invalid-input-text-err" *ngIf="address?.errors?.required">Address is
                            required</span>
                            <span class="invalid-input-text-err" *ngIf="address?.errors?.maxlength">Address should not
                                be more than 100 characters</span>
    
                    </ng-container>
                </div>

                <div class="form-floating"
                [ngClass]="commission?.invalid && (commission?.dirty || commission?.touched)?'invalid-input':''">
                <input onkeypress='return event.charCode >= 48 && event.charCode <= 57' type="text" class="form-control" formControlName="commission"
                    id="floatingInput" placeholder="name@example.com" maxlength="3" appNumbersonly
                 (focusout)="commission?.errors?.required?showCountryCode=false: '' ">
                <label for="floatingInput">Commission (%)</label>
                <ng-container *ngIf="commission?.invalid && (commission?.dirty || commission?.touched)">
                    <span class="invalid-input-text-err" *ngIf="commission?.errors?.required">Commission is
                        required</span>
                    <span class="invalid-input-text-err" *ngIf="commission?.errors?.pattern">Commission should not
                        be greater than 100%</span>
    
                </ng-container>
            </div>

                <button type="submit" class="btn primary w-100">Add</button>
            </form>
        </div>
    </div>